<template>
  <svg
    :class="computedClass"
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21 8V16C21 18 20 19 18 19H6C4 19 3 18 3 16V8C3 6 4 5 6 5H18C20 5 21 6 21 8Z"
      :stroke="color"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path d="M3 10H21" :stroke="color" stroke-width="1.5" />
    <path d="M3 14H21" :stroke="color" stroke-width="1.5" />
    <path d="M8 5V19" :stroke="color" stroke-width="1.5" />
    <path d="M16 5V19" :stroke="color" stroke-width="1.5" />
  </svg>
</template>

<script setup lang="ts">
import { computed } from "vue";

interface Props {
  size?: number | string;
  color?: string;
  class?: string;
}

const props = withDefaults(defineProps<Props>(), {
  size: 24,
  color: "currentColor",
  class: "",
});

const computedClass = computed(() => props.class);
</script>
